import { Component, ViewChild, ElementRef, Input, HostListener } from '@angular/core';

@Component({
  selector: 'ins-overflow-span',
  templateUrl: './overflow-span.component.html',
  styleUrls: ['./overflow-span.component.scss', '../../../../../apps/did/src/app/shared/soti-tooltip.scss'],
})
export class OverflowSpanComponent {
  @ViewChild('containerWrapper', { static: false }) containerWrapper: ElementRef;
  @ViewChild('textWrapper', { static: false }) textWrapper: ElementRef;

  @Input()
  content = '';

  @Input()
  position = 'top';

  @Input()
  tooltipDisabled = false;

  @Input()
  hideDelay = 0;

  @Input()
  showDelay = 0;

  @Input()
  tooltipClass = '';

  tooltipVisible = false;

  @HostListener('mouseover')
  checkForTooltip() {
    if (this.containerWrapper && this.containerWrapper.nativeElement) {
      this.tooltipVisible =
        this.containerWrapper.nativeElement.offsetWidth < this.textWrapper.nativeElement.scrollWidth;
    }
  }
}
